import "./index.css";

import { QueryClientProvider } from "@tanstack/react-query";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { isNullish } from "@core/foundation/types";

import { relayConsole } from "@react/foundation/debug";
import { LoggerProvider } from "@react/foundation/logger";
import { createQueryClient } from "@react/foundation/query";
import { Toaster } from "@react/ui-primitives/sonner";

import { App } from "./App.tsx";
import { logger } from "./bootstrap/logger.ts";
import { signinOnReturn } from "./features/auth/index.ts";

if (import.meta.hot) {
  relayConsole(import.meta.hot);
}

// oxlint-disable-next-line typescript/no-floating-promises
signinOnReturn(window.location.href);

const queryClient = createQueryClient(logger);

const rootElement = document.querySelector("#root");

if (isNullish(rootElement)) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter
      future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
    >
      <LoggerProvider logger={logger}>
        <QueryClientProvider client={queryClient}>
          <App />
          <Toaster richColors />
        </QueryClientProvider>
      </LoggerProvider>
    </BrowserRouter>
  </StrictMode>,
);
